//
//
//
//
//

import _ from 'underscore'
// import DIC from '@/index/dictonary'

export default {
  props: {
    tab: {
      default: ''
    }
  },
  data: () => ({
    table: [],
    table: [],
    loading: false
  }),
  components: {
    PageMain: () => import('./components/PageMain/index.vue')
  },
  watch: {
    tab: {
      handler (val) {
        if (val && val == 'allocate') {
          this.handleLoadTableData()
        }
      },
      immediate: true
    }
  },
  mounted () {
  },
  methods: {
    queryDealerByGoods(row, table) {
      return new Promise((resolve, reject) => {
        let data = _.pick(row, 'goodsId')
        this.$axios.get('/mtea/store/admin/dealer/queryByGoods', { params: data }).then(res => {
          _.each(res, (t, i, l) => {
            _.each(t.locations, (m, j) => {
              if (m.address == undefined) {
                m.address = `${m.province}-${m.city}-${m.area}`
              }
            })
          })
          let selectedDealer = []
          row.dealerList = res
          table.push(row)
          if (res.length > 0) {
            let dealerInfo = res[0]
            let d = _.extend({selectedDealerId:dealerInfo.dealerId, selectedLocationId: undefined, dealerInfo: dealerInfo, selectedNum: row.surplusNumber})
            if (dealerInfo.locations && dealerInfo.locations.length > 0) {
              d.selectedLocationId = dealerInfo.locations[0].locationId
            }
            // selectedDealer.push(d)
          }
          row.selectedDealer = selectedDealer
        }).finally(() => {
          resolve()
        })
      })
    },
    queryGoodsInfo (row, table) {
      return new Promise((resolve, reject) => {
        let data = _.pick(row, 'goodsId')
        this.$axios.get('/mtea/store/admin/goods/info', { params: data }).then(res => {
          let cb = function(t, i, l) {
            if (t.goodsId == data.goodsId) {
              t.goodsInfo = res
            }
            if (t.images) {
              t.images = t.images.split(',')
            }
          }
          _.each(table, cb)
        }).finally(() => {
          resolve()
        })
      })
    },
    handleLoadTableData () {
      this.loading = true
      let data = _.extend({})
      // console.log('data', data)
      this.$axios.get('/mtea/store/admin/purchase/allocate/list', { params: data }).then(res => {
        // console.log('res', res)
        let table = []
        let a = []
        let b = []
        _.each(res, (t, i) => {
          a.push(this.queryDealerByGoods(t, table))
        })
        Promise.all(a).then(() => {
          _.each(res, (t, i) => {
            b.push(this.queryGoodsInfo(t, table))
          })
          Promise.all(b).then(() => {
            table = _.sortBy(table, function(item){ return item.id })
            this.table = table
            this.loading = false
          })
        })
      }).finally(() => {
      })
    }
  }
}
